const baseFitmentFields = ['Year', 'Make', 'Model'];
const extraFitmentFields = ['Submodel'];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'tire_rim'];
const ignoreFields = [...wheelsFields, ...tiresFields];

const categorySelectionPageUrl = '/category-list/';
const brandSelectionPageUrl = '/brands/';

window.Convermax.handleProductCompareClick = ({ target }) => {
  target.closest('.custom-compare').classList.toggle('clicked');

  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );

  const compareBtn = window.document.body.querySelector('.navUser-item--compare');
  if (!compareBtn) {
    return;
  }

  compareBtn.classList.toggle('show', productsIdsToCompare.length > 1);
  compareBtn.querySelector('.navUser-action .countPill').textContent = productsIdsToCompare.length;
  compareBtn.href = `/compare/${productsIdsToCompare.join('/')}`;
};

window.Convermax.onCardImageSliderClick = (e) => {
  if (e.currentTarget.querySelector('.card-img-container')) {
    const images = [...e.currentTarget.querySelector('.card-img-container').childNodes];
    const activeImage = e.currentTarget.querySelector('.is-active');
    const sliderButton = e.target.closest('.card-image-prev, .card-image-next');

    if (sliderButton) {
      e.preventDefault();
      e.stopPropagation();

      activeImage.classList.remove('is-active');

      if (sliderButton.classList.contains('card-image-prev')) {
        if (activeImage.classList.contains('first')) {
          images.find((img) => img.classList.contains('last'))?.classList?.add('is-active');
        } else {
          activeImage.previousElementSibling.classList.add('is-active');
        }
      } else {
        if (activeImage.classList.contains('last')) {
          images.find((img) => img.classList.contains('first'))?.classList?.add('is-active');
        } else {
          activeImage.nextElementSibling.classList.add('is-active');
        }
      }
    }
  }
};

export default {
  platform: 'bigcommerce',
  defaultView: 'grid',
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc', 'date_created', 'date_created:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  pagination: {
    centralRange: 1,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
    disableVehicleStorage: true,
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: ['brand', 'category'].map((className) => `body.${className} .page`).join(),
      template: 'SearchPage',
    },
    {
      name: 'FilterChips',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchBox',
      location: '#quickSearch',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        insertAfter: '.navUser .navUser-item--wishlist',
        class: 'cm_desktop-hide',
        wrapper: 'li',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: '#cm_ymm',
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: true,
      columnBreakpoint: 768,
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'Garage',
      location: {
        insertBefore: '.navUser .navUser-item--cart',
        wrapper: 'li',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        insertBefore: 'body.product section.productView-details .productView-info',
      },
      template: 'fitmentSearch/verifyFitment',
      isAlwaysColumnLayout: true,
    },
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: {
        insertAfter: '.productView-description .tabs .tab:first-child',
        wrapper: 'li',
        class: 'tab',
      },
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'FitmentTable',
      location: '#cm_fitment-table',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_collection-list',
      template: 'facetTiles/hierarchicalContainer',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: 'body.brands .brandGrid',
      template: 'facetTiles/alphabeticalContainer',
      view: 'grid',
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
